export enum MBAL_TABLE_DATA_NAME {
  CLAIM_TYPE = 'MBAL Claim Types',
  DOCUMENT_TYPE = 'MBAL Document Types',
}

export enum FIELD {
  CLAIM_TYPE = 'claim_type',
  DOCUMENT_TYPE = 'document_type',
}
